'use strict';

function openflyout($flyout, options) {
    var opts = options || {};
    var flyoutId = $flyout.attr('id');
    var $closeButton = $flyout.find('.closeflyout');

    if ($('body').hasClass('flyout-active-' + flyoutId)) {
        return;
    }

    $('body').off('click.' + flyoutId + '.flyoutEvents');

    $flyout.removeAttr('hidden');
    $('body').addClass('flyout-active-' + flyoutId);
    void $flyout[0].offsetWidth;
    $flyout.css('transform', 'translateX(0)');
    $flyout.trigger('flyout:opened');

    if (opts.triggeredByKeyboard) {
        setTimeout(function () {
            $closeButton.first().attr('tabindex', '0').focus();
        }, 0);
    }

    $closeButton
        .off('click.' + flyoutId + '.flyoutEvents')
        .on('click.' + flyoutId + '.flyoutEvents', function () {
            closeflyout($flyout);
        });

    if (opts.dismissOnOutsideClick !== false) {
        $('body').on('click.' + flyoutId + '.flyoutEvents', function (event) {
            if ($(event.target).closest($flyout).length) {
                return;
            }

            closeflyout($flyout);
        });
    }
}

function closeflyout($flyout, instant) {
    var flyoutId = $flyout.attr('id');

    if (instant) {
        $flyout.attr('hidden', true);
        $flyout.css('transform', '');
        $flyout.trigger('flyout:closed');
        $('body').removeClass('flyout-active-' + flyoutId);
        $('body').off('click.' + flyoutId + '.flyoutEvents');
        return;
    }

    $flyout.css('transform', 'translateX(100%)');

    setTimeout(function () {
        $flyout.attr('hidden', true);
        $flyout.css('transform', '');
        $flyout.trigger('flyout:closed');
        $('body').removeClass('flyout-active-' + flyoutId);
        $('body').off('click.' + flyoutId + '.flyoutEvents');
    }, 300);
}

module.exports = {
    openflyout: openflyout,
    closeflyout: closeflyout
};
